import { isString } from "@/services/util";

const initMessage = () => ({
  mode: null,
  text: null,
  timeout: 30000
});
//
// initial state
const state = {
  message: initMessage(),
  alert: null,
  timeout: 30000,

  paymentDialog: false,
  paymentSessionId: -1,
  paymentComplete: false
};

const getters = {};

export const mutations = {
  // message - snackbar
  setMessage(state, { text, mode = "success", timeout = 30000 }) {
    console.log(`Set notification message, text: ${text}, mode: ${mode}`);
    state.message = {
      text,
      mode,
      timeout
    };
  },
  clearMessage(state) {
    state.message = initMessage();
  },

  // alert - dialog
  setAlert(state, alert) {
    state.alert = alert;
  },

  // payment - dialog
  newPaymentSession(state) {
    state.paymentSessionId = new Date().getTime();
    state.paymentComplete = false;
    state.paymentDialog = true;
  },

  updatePaymentDialog(state, val) {
    state.paymentDialog = val;
  },

  setPaymentComplete(state) {
    state.paymentComplete = true;
  }
};

// actions
const actions = {
  showMessage({ commit }, payload) {
    commit("clearMessage");
    setTimeout(
      () =>
        commit("setMessage", isString(payload) ? { text: payload } : payload),
      0
    );
  },
  clearMessage({ commit }) {
    commit("clearMessage");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
